import { useSelector } from 'react-redux';
import { Surface, Txt } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import { selectBillingInfo } from '@app/redux/billingInfo';

import { OverviewAutoPayMethod } from './autopay-method';

import styles from './balance-card.module.scss';

export const PreinstallBalanceCard = () => {
  const { t } = useTranslation('Overview', { keyPrefix: 'balanceCard' });

  const {
    billingInfo: { totalBalance },
  } = useSelector(selectBillingInfo);

  return (
    <div className={styles['balanceCard']} data-cy="preinstall-balace-card">
      <Surface theme="dark" className={styles['content']}>
        <div>
          <Txt variant="bodyLargeBold">{t('title')}</Txt>
          <Txt variant="heading1">{totalBalance.text}</Txt>
        </div>
        <Txt variant="smallRegular">{t('preinstallAccount')}</Txt>
        <div className={styles['autoPay']}>
          <OverviewAutoPayMethod />
        </div>
      </Surface>
    </div>
  );
};
